// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatsSummaryPanel_panel__mtefZ {
  padding: 10px 0;
}

.StatsSummaryPanel_header__mIAPe {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.StatsSummaryPanel_title__U2Wq6 {
  margin: 0;
  font-size: 16.38px;
  font-weight: 600;
  color: #838383;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.StatsSummaryPanel_scope__ZpzQy {
  margin-left: 5px;
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color);
  text-transform: none;
  letter-spacing: 0;
}

.StatsSummaryPanel_headerRight__RG4vr {
  display: flex;
  align-items: baseline;
  gap: 20px;
  flex-wrap: wrap;
}

.StatsSummaryPanel_overview__ZkmBl {
  display: inline-flex;
  align-items: baseline;
  gap: 10px;
  font-size: 12px;
  color: #acacac;
  flex-wrap: wrap;
}
.StatsSummaryPanel_overview__ZkmBl strong {
  color: #838383;
  font-weight: 600;
}

.StatsSummaryPanel_overviewItem__GiHMe {
  white-space: nowrap;
}

.StatsSummaryPanel_totalBlock__k5Xhw {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1;
}

.StatsSummaryPanel_totalNumber__tJm7c {
  font-size: 2.2em;
  font-weight: 700;
  color: var(--primary-color);
  font-family: monospace;
  line-height: 1;
}

.StatsSummaryPanel_totalLabel__MrgH8 {
  margin-top: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #acacac;
}

.StatsSummaryPanel_grid__z6A4Y {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 5px;
}

.StatsSummaryPanel_tile__WUTn5 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px;
  border: 1px solid #f4f5f7;
  border-left-width: 4px;
  border-radius: 3px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  color: #838383;
}
.StatsSummaryPanel_tile__WUTn5:hover:not(:disabled) {
  background: #f4f5f7;
}
.StatsSummaryPanel_tile__WUTn5:disabled {
  cursor: default;
  opacity: 0.55;
}

.StatsSummaryPanel_tileTopRow__bnek3 {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 6px;
}

.StatsSummaryPanel_tileCount__s1Fvv {
  font-size: 1.8em;
  font-weight: 600;
  color: var(--primary-color);
  line-height: 1;
}

.StatsSummaryPanel_tilePct__E36lT {
  font-size: 12px;
  font-family: monospace;
  font-weight: 600;
  color: #acacac;
  line-height: 1;
}

.StatsSummaryPanel_tileBar__RFi04 {
  position: relative;
  display: block;
  height: 4px;
  background: #f4f5f7;
  border-radius: 2px;
  margin-top: 4px;
  overflow: hidden;
}

.StatsSummaryPanel_tileBarFill__M6mZw {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 2px;
  transition: width 0.2s ease;
}

.StatsSummaryPanel_barFill_processed__TKwHX {
  background: var(--accent-color);
}

.StatsSummaryPanel_barFill_processing__Xx0d5 {
  background: #3b7fd4;
}

.StatsSummaryPanel_barFill_pending__ns97J {
  background: #00bcd4;
}

.StatsSummaryPanel_barFill_waiting_archive__deRYP {
  background: #64b5f6;
}

.StatsSummaryPanel_barFill_duplicate__d6LZm {
  background: #8e6acb;
}

.StatsSummaryPanel_barFill_upload_failed__oMtFw {
  background: #efa12c;
}

.StatsSummaryPanel_barFill_failed__KymY7 {
  background: #df6767;
}

.StatsSummaryPanel_barFill_no_data__FAjqk {
  background: #7a7a7a;
}

.StatsSummaryPanel_tileLabel__9CEOY {
  font-size: 14px;
}

.StatsSummaryPanel_tileScope__bcgpx {
  font-size: 10px;
  color: #acacac;
  font-style: italic;
}

.StatsSummaryPanel_active__VwPxP {
  background: #f4f5f7;
  border-color: var(--primary-color);
}

.StatsSummaryPanel_loaderWrap__HRwiz {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.StatsSummaryPanel_processed__ELp40 {
  border-left-color: var(--accent-color);
}

.StatsSummaryPanel_processing__T9W\\+V {
  border-left-color: #3b7fd4;
}

.StatsSummaryPanel_pending__oHw7R {
  border-left-color: #00bcd4;
}

.StatsSummaryPanel_waiting_archive__nRE5b {
  border-left-color: #64b5f6;
}

.StatsSummaryPanel_duplicate__w-r2v {
  border-left-color: #8e6acb;
}

.StatsSummaryPanel_upload_failed__-kWkg {
  border-left-color: #efa12c;
}

.StatsSummaryPanel_failed__co6o2 {
  border-left-color: #df6767;
}

.StatsSummaryPanel_no_data__71R2N {
  border-left-color: #7a7a7a;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/StatsSummaryPanel/StatsSummaryPanel.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SCDS;EDET,mBCFS;EDGT,eAAA;AAFF;;AAKA;EACE,SAAA;EACA,kBCIa;EDHb,gBAAA;EACA,cEXS;EFYT,yBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gBCjBS;EDkBT,eAAA;EACA,gBAAA;EACA,2BE7BQ;EF8BR,oBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,SC1BS;ED2BT,eAAA;AAFF;;AAKA;EACE,oBAAA;EACA,qBAAA;EACA,SClCS;EDmCT,eAAA;EACA,cEtCS;EFuCT,eAAA;AAFF;AAIE;EACE,cEzCO;EF0CP,gBAAA;AAFJ;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AAHF;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,2BErEQ;EFsER,sBAAA;EACA,cAAA;AAHF;;AAMA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cExES;AFqEX;;AAMA;EACE,aAAA;EACA,2DAAA;EACA,QC7ES;AD0EX;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aCxFU;EDyFV,yBAAA;EACA,sBAAA;EACA,kBC9Fc;ED+Fd,gBEnFM;EFoFN,gBAAA;EACA,eAAA;EACA,0DAAA;EACA,cE5FS;AFyFX;AAKE;EACE,mBElGO;AF+FX;AAME;EACE,eAAA;EACA,aAAA;AAJJ;;AAQA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;AALF;;AAQA;EACE,gBAAA;EACA,gBAAA;EACA,2BE3HQ;EF4HR,cAAA;AALF;;AAQA;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cE3HS;EF4HT,cAAA;AALF;;AAQA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,mBErIS;EFsIT,kBAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AALF;;AAQA;EAA2B,+BExJlB;AFoJT;;AAKA;EAA2B,mBAAA;AAD3B;;AAEA;EAA2B,mBAAA;AAE3B;;AADA;EAA2B,mBAAA;AAK3B;;AAJA;EAA2B,mBAAA;AAQ3B;;AAPA;EAA2B,mBAAA;AAW3B;;AAVA;EAA2B,mBEnJnB;AFiKR;;AAbA;EAA2B,mBAAA;AAiB3B;;AAfA;EACE,eCpJe;ADsKjB;;AAfA;EACE,eAAA;EACA,cEjKS;EFkKT,kBAAA;AAkBF;;AAfA;EACE,mBExKS;EFyKT,kCE/KQ;AFiMV;;AAfA;EACE,aAAA;EACA,uBAAA;EACA,aC7KY;AD+Ld;;AAfA;EAAmB,sCEtLV;AFyMT;;AAlBA;EAAmB,0BAAA;AAsBnB;;AArBA;EAAmB,0BAAA;AAyBnB;;AAxBA;EAAmB,0BAAA;AA4BnB;;AA3BA;EAAmB,0BAAA;AA+BnB;;AA9BA;EAAmB,0BAAA;AAkCnB;;AAjCA;EAAmB,0BEjLX;AFsNR;;AApCA;EAAmB,0BAAA;AAwCnB","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.panel {\n  padding: $padding-m 0;\n}\n\n.header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: $margin-m;\n  margin-bottom: $margin-m;\n  flex-wrap: wrap;\n}\n\n.title {\n  margin: 0;\n  font-size: $h3-font-size;\n  font-weight: 600;\n  color: $grey-400;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.scope {\n  margin-left: $margin-s;\n  font-size: 12px;\n  font-weight: 500;\n  color: $primary;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.headerRight {\n  display: flex;\n  align-items: baseline;\n  gap: $margin-l;\n  flex-wrap: wrap;\n}\n\n.overview {\n  display: inline-flex;\n  align-items: baseline;\n  gap: $margin-m;\n  font-size: 12px;\n  color: $grey-300;\n  flex-wrap: wrap;\n\n  strong {\n    color: $grey-400;\n    font-weight: 600;\n  }\n}\n\n.overviewItem {\n  white-space: nowrap;\n}\n\n.totalBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  line-height: 1;\n}\n\n.totalNumber {\n  font-size: 2.2em;\n  font-weight: 700;\n  color: $primary;\n  font-family: monospace;\n  line-height: 1;\n}\n\n.totalLabel {\n  margin-top: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: $grey-300;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: $margin-s;\n}\n\n.tile {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: $padding-m;\n  border: 1px solid $grey-100;\n  border-left-width: 4px;\n  border-radius: $border-radius;\n  background: $white;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  color: $grey-400;\n\n  &:hover:not(:disabled) {\n    background: $grey-100;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.55;\n  }\n}\n\n.tileTopRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.tileCount {\n  font-size: 1.8em;\n  font-weight: 600;\n  color: $primary;\n  line-height: 1;\n}\n\n.tilePct {\n  font-size: 12px;\n  font-family: monospace;\n  font-weight: 600;\n  color: $grey-300;\n  line-height: 1;\n}\n\n.tileBar {\n  position: relative;\n  display: block;\n  height: 4px;\n  background: $grey-100;\n  border-radius: 2px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n\n.tileBarFill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.2s ease;\n}\n\n.barFill_processed       { background: $accent; }\n.barFill_processing      { background: #3b7fd4; }\n.barFill_pending         { background: #00bcd4; }\n.barFill_waiting_archive { background: #64b5f6; }\n.barFill_duplicate       { background: #8e6acb; }\n.barFill_upload_failed   { background: #efa12c; }\n.barFill_failed          { background: $error; }\n.barFill_no_data         { background: #7a7a7a; }\n\n.tileLabel {\n  font-size: $base-font-size;\n}\n\n.tileScope {\n  font-size: 10px;\n  color: $grey-300;\n  font-style: italic;\n}\n\n.active {\n  background: $grey-100;\n  border-color: $primary;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: $padding-xxl;\n}\n\n.processed       { border-left-color: $accent; }\n.processing      { border-left-color: #3b7fd4; }\n.pending         { border-left-color: #00bcd4; }\n.waiting_archive { border-left-color: #64b5f6; }\n.duplicate       { border-left-color: #8e6acb; }\n.upload_failed   { border-left-color: #efa12c; }\n.failed          { border-left-color: $error; }\n.no_data         { border-left-color: #7a7a7a; }\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `StatsSummaryPanel_panel__mtefZ`,
	"header": `StatsSummaryPanel_header__mIAPe`,
	"title": `StatsSummaryPanel_title__U2Wq6`,
	"scope": `StatsSummaryPanel_scope__ZpzQy`,
	"headerRight": `StatsSummaryPanel_headerRight__RG4vr`,
	"overview": `StatsSummaryPanel_overview__ZkmBl`,
	"overviewItem": `StatsSummaryPanel_overviewItem__GiHMe`,
	"totalBlock": `StatsSummaryPanel_totalBlock__k5Xhw`,
	"totalNumber": `StatsSummaryPanel_totalNumber__tJm7c`,
	"totalLabel": `StatsSummaryPanel_totalLabel__MrgH8`,
	"grid": `StatsSummaryPanel_grid__z6A4Y`,
	"tile": `StatsSummaryPanel_tile__WUTn5`,
	"tileTopRow": `StatsSummaryPanel_tileTopRow__bnek3`,
	"tileCount": `StatsSummaryPanel_tileCount__s1Fvv`,
	"tilePct": `StatsSummaryPanel_tilePct__E36lT`,
	"tileBar": `StatsSummaryPanel_tileBar__RFi04`,
	"tileBarFill": `StatsSummaryPanel_tileBarFill__M6mZw`,
	"barFill_processed": `StatsSummaryPanel_barFill_processed__TKwHX`,
	"barFill_processing": `StatsSummaryPanel_barFill_processing__Xx0d5`,
	"barFill_pending": `StatsSummaryPanel_barFill_pending__ns97J`,
	"barFill_waiting_archive": `StatsSummaryPanel_barFill_waiting_archive__deRYP`,
	"barFill_duplicate": `StatsSummaryPanel_barFill_duplicate__d6LZm`,
	"barFill_upload_failed": `StatsSummaryPanel_barFill_upload_failed__oMtFw`,
	"barFill_failed": `StatsSummaryPanel_barFill_failed__KymY7`,
	"barFill_no_data": `StatsSummaryPanel_barFill_no_data__FAjqk`,
	"tileLabel": `StatsSummaryPanel_tileLabel__9CEOY`,
	"tileScope": `StatsSummaryPanel_tileScope__bcgpx`,
	"active": `StatsSummaryPanel_active__VwPxP`,
	"loaderWrap": `StatsSummaryPanel_loaderWrap__HRwiz`,
	"processed": `StatsSummaryPanel_processed__ELp40`,
	"processing": `StatsSummaryPanel_processing__T9W+V`,
	"pending": `StatsSummaryPanel_pending__oHw7R`,
	"waiting_archive": `StatsSummaryPanel_waiting_archive__nRE5b`,
	"duplicate": `StatsSummaryPanel_duplicate__w-r2v`,
	"upload_failed": `StatsSummaryPanel_upload_failed__-kWkg`,
	"failed": `StatsSummaryPanel_failed__co6o2`,
	"no_data": `StatsSummaryPanel_no_data__71R2N`
};
export default ___CSS_LOADER_EXPORT___;
